<ul [class.parent]="!child" class="comments-block">
    <li *ngFor="let comment of comments">
        <app-comment [child]="child" [comment]="comment" [post]="post"></app-comment>

        <div class="commentReplies" *ngIf="!comment.minimiseReplies">
            <app-comments-list [child]="true" [comments]="comment.children"
                               [post]="post"></app-comments-list>
        </div>
    </li>
</ul>
